export const DeleteType = {
  messages: 'Message',
  contactPlan: 'Contact Plan',
  contactCriteria: 'Message Code',
  lists: 'List',
  contacts: 'Contact'
};
